module.exports = __webpack_public_path__ + "static/media/nik-mall-logo.5f8c693b.png";